// c:\Users\xiaolin\Desktop\project_react\src\pages\home\components\CustomGridDrawing.tsx
import React from "react";

interface CustomGridDrawingProps {
  drawingMode: boolean;
  onDrawingChange: (drawing: boolean) => void;
}

export default function CustomGridDrawing({ drawingMode, onDrawingChange }: CustomGridDrawingProps) {
  return (
    <>
      <button
        onClick={() => onDrawingChange(!drawingMode)}
        className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
          drawingMode
            ? "bg-slate-800 text-white border border-slate-700"
            : "bg-slate-50 text-slate-600 border border-slate-200 hover:border-slate-400 hover:text-slate-800"
        }`}
      >
        <span>{drawingMode ? "退出绘制模式" : "自定义网格绘制"}</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className={`ri-${drawingMode ? "close" : "edit-box"}-line text-base`} />
        </div>
      </button>

      {drawingMode && (
        <div className="mt-2 bg-slate-800/8 rounded-lg p-2 text-center">
          <p className="text-slate-700 text-xs leading-relaxed">
            在地图上依次点击添加顶点<br />
            <span className="text-slate-500 text-xs">双击或点击"完成绘制"结束，完成后点击网格查看概览</span>
          </p>
        </div>
      )}
    </>
  );
}